import {action} from '@api'
import {IServerPDFQueryPayload, IServerRenderedPDFTemplateInstance} from '@modules/pdf'
import {DocumentLoadEvent, ScrollMode, SpecialZoomLevel} from '@react-pdf-viewer/core'
import {StoresInstance} from '@stores'
import {computed} from 'mobx'
import {ServerPDFTemplate} from '../'

export class AssortmentPDFTemplate extends ServerPDFTemplate implements IServerRenderedPDFTemplateInstance {
  constructor(public stores: StoresInstance) {
    super(stores, 'assortment')
  }

  @computed override get text() {
    return this.strings.assortments
  }

  @computed override get defaultPdfFilename(): string {
    const {stores: {users: {user: {name}}}, catalog: {componentStores: {assortmentRoots: {catalog: root}}}} = this

    if (!root) return this._defaultPdfFilename

    if (root.assortmentCount === 1) {
      return _.first(root.cardStores).newPdfFilename
    }

    return `${name}` // - ${root.assortmentCount} Boards (${new Date().toLocaleString()})`

  }

  override get isDisabled() {
    const {catalog: {componentStores: {assortmentRoots: {catalog: root}}}} = this

    return root == null || root.assortmentCount === 0
  }

  @action onDocumentLoad = (e: DocumentLoadEvent) => {
    const {doc} = e,
      {
        cloudPDF: {
          defaultLayoutPluginInstance: {
            bookmarkPluginInstance,
            attachmentPluginInstance,
            thumbnailPluginInstance,
            toolbarPluginInstance: {scrollModePluginInstance, zoomPluginInstance}
          },
          component: {selectedPdf}
        },
      } = this

    scrollModePluginInstance.switchScrollMode(selectedPdf?.entry?.pages === 1 ? ScrollMode.Vertical : ScrollMode.Wrapped)
    zoomPluginInstance.zoomTo(SpecialZoomLevel.PageFit)
    //thumbnailPluginInstance.
  }

  override get catalogFeatures() {
    return {
      // groupBy: false,
      // viewOptions: false,
      // sortBy: false,
      // imageSources: false,
      catalogFooter: false
    }
  }

  override get settings() {
    const {catalog: {settings: {assortment}}} = this

    return assortment
  }
}


// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/templates/assortment/AssortmentPDFTemplate.ts